import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import type { LucideIcon } from "lucide-react";
import { BrandMark } from "./BrandMark";

export function AuthSidePanel({
  eyebrow,
  title,
  lead,
  features,
  footer,
}: {
  eyebrow: string;
  title: ReactNode;
  lead: string;
  features: Array<{ icon: LucideIcon; label: string }>;
  footer: string;
}) {
  return (
    <aside className="brand-panel">
      <div className="brand-panel__top">
        <Link to="/" className="brand-lockup brand-lockup--link">
          <BrandMark />
          <div>
            <strong>Cafe System Control</strong>
            <span>Workspace</span>
          </div>
        </Link>
      </div>

      <div className="brand-panel__body">
        <p className="eyebrow eyebrow--light">{eyebrow}</p>
        <h1>{title}</h1>
        <p className="brand-lead">{lead}</p>

        <div className="brand-features">
          {features.map((feature) => {
            const Icon = feature.icon;
            return (
              <div className="brand-feature" key={feature.label}>
                <Icon size={17} />
                <span>{feature.label}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="brand-panel__footer">
        <span>{footer}</span>
      </div>
    </aside>
  );
}
